import styled from 'styled-components'
import SearchIcon from '~/components/icons/ui/32px_zoom-2.svg'
import CloseIcon from '~/components/icons/ui/64px_small-remove.svg'

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow(1)};
`

interface BaseButtonProps {
  isOpen: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
}

export const BaseButton = ({ isOpen, onClick }: BaseButtonProps) => {
  return (
    <Button onClick={onClick}>
      {isOpen ? (
        <CloseIcon fill='#0C2340' width={20} height={20} />
      ) : (
        <SearchIcon fill='#0C2340' width={20} height={20} />
      )}
    </Button>
  )
}
